<template>
  <div id="all">
    <!-- <h3>按条件搜索人才列表</h3> -->
    <!-- 搜索 -->
    <!-- <Select @search="search" @reset="reset"/> -->
    <!-- 操作 -->
    <!-- <h3>首页</h3>
    <h3 @click="gonotice()">跳转到审批通知页面</h3>-->
    <div class="main-top">
      <div class="main-left">
        <div class="search">
          <el-card class="search_card">
            <div class="searchbox">
              <el-input
                placeholder="检索案例"
                v-model="input"
                size="small"
                prefix-icon="el-icon-search"
                clearable
              ></el-input>
              <el-button type="warning" size="mini" @click="search"
                >搜索</el-button
              >
            </div>
          </el-card>
        </div>
        <div class="enter">
          <el-card class="enter-card">
            <div class="quickbox">
              <div class="title">快捷录入</div>
              <div class="box">
                <div
                  class="quickcontent"
                  v-for="(item, index) in quickcontent"
                  ref="quick"
                  @click="quicksearch(item)"
                  :key="index"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
          </el-card>
        </div>
        <div class="main-bottim"></div>
      </div>
      <div class="main-right">
        <el-card class="notice_card">
          <div class="noticebox">
            <div class="title" @click="gonotice()">审批通知</div>
            <div class="notice">
              <div class="content" v-for="(item, index) in notice" :key="index">
                <div
                  style="
                    font-size: 16px;
                    color: #111827;

                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                  "
                  @click="Look(item)"
                >
                  <span
                    v-if="item.msgType == 'case_entry'"
                    style="cursor: pointer"
                  >
                    案件<span>{{ item.bcase }}</span>
                    <span v-if="item.con.includes('需要审批')">
                      提醒您审批</span
                    >
                    <span v-if="item.con.includes('通过')">通过审批</span>
                    <span v-if="item.con.includes('驳回')">被驳回</span>
                  </span>

                  <span
                    v-if="item.msgType == 'tender_entry'"
                    style="cursor: pointer"
                  >
                    <span v-if="item.con.includes('需要审批')">
                      <span>{{ item.tender }}</span>
                      的投标申请，提醒您审批</span
                    >
                    <span v-if="item.con.includes('通过')"
                      >您的投标申请通过审批</span
                    >
                    <span v-if="item.con.includes('驳回')"
                      >您的投标申请被驳回</span
                    >
                  </span>
                  <span
                    style="cursor: pointer"
                    v-if="item.msgType.includes('_seal')"
                  >
                    <span v-if="item.con.includes('需要审批')">
                      <span>{{ item.seal }}</span>
                      的用章申请，提醒您审批</span
                    >
                    <span v-if="item.con.includes('通过')"
                      >您的用章申请通过审批</span
                    >
                    <span v-if="item.con.includes('驳回')"
                      >您的用章申请被驳回</span
                    >
                  </span>

                  <span
                    style="cursor: pointer"
                    v-if="item.msgType == 'adviser_entry'"
                  >
                    <span v-if="item.con.includes('需要审批')">
                      <span>{{ item.advisers }}</span>
                      的顾问申请，提醒您审批</span
                    >
                    <span v-if="item.con.includes('通过')"
                      >您的顾问申请通过审批</span
                    >
                    <span v-if="item.con.includes('驳回')"
                      >您的顾问申请被驳回</span
                    >
                  </span>
                </div>
                <div
                  style="
                    min-width: 150px;
                    text-align: right;
                    font-size: 14px;
                    color: #718096;
                    padding-right: 12px;
                  "
                >
                  {{
                    handleTime(
                      JsonFTime(item.noticeTime),
                      'yyyy-MM-dd HH:mm:ss'
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="things">
      <el-card class="schedule">
        <div class="top">
          <div class="title">待办事件</div>
          <div class="addthing" @click="addSchedule">新增待办</div>
        </div>
        <div class="main">
          <div class="main_con" v-for="item in resDate">
            <div class="detail">
              <div class="detail-left" @click="detail(item.id)">
                <div class="d-top">
                  <div class="icon"></div>
                  <div>{{ item.startTimeData }}</div>
                </div>
                <div class="d-main">{{ item.abstract }}</div>
                <div></div>
              </div>
              <div class="detail-right" @click="SuccessOk(item.id)">
                不再提醒
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 查看编辑事件弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
      label-width="80px"
      @close="closedialog"
    >
      <!-- <div style="width: 100%;text-align: centers;">新增代办</div> -->
      <el-form
        @submit.native.prevent
        ref="editForm"
        :model="editForm"
        :rules="editrules"
      >
        <!-- <el-form-item label="活动名称" label-width="80px">
              <el-input v-model="editForm.content"></el-input>
            </el-form-item> -->

        <el-form-item label="工作摘要" label-width="90px" prop="abstract">
          <el-input
            v-model="editForm.abstract"
            clearable
            :disabled="isedit"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作详情" label-width="90px" prop="detail">
          <el-input
            v-model="editForm.detail"
            clearable
            :disabled="isedit"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联案件" label-width="90px" prop="caseId">
              <el-select
                v-model="editForm.caseId"
                placeholder="请选择"
                clearable
                :disabled="isedit"
              >
                <el-option
                  v-for="item in LinkCase"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联顾问" label-width="90px" prop="adviserId">
              <el-select
                v-model="editForm.adviserId"
                placeholder="请选择"
                clearable
                :disabled="isedit"
              >
                <el-option
                  v-for="item in LinkAdviser"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提醒" label-width="90px" prop="remind">
              <el-select
                v-model="editForm.remind"
                placeholder="请选择"
                :disabled="isedit"
              >
                <el-option
                  v-for="item in IsorNo"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="日期" label-width="90px" prop="date">
            <el-date-picker
              :disabled="isedit"
              @change="dateChange"
              v-model="editForm.date"
              type="date"
              placeholder="请选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row v-if="editForm.date">
          <el-col :span="12">
            <el-form-item label="时间" label-width="90px" prop="startTime">
              <el-time-picker
                placeholder="开始时间"
                :disabled="isedit"
                v-model="editForm.startTime"
                format="HH:mm"
                style="width: 100%"
                @change="selectTime"
                :picker-options="{
                  selectableRange: selectstart
                }"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="90px" prop="endTime">
              <el-time-picker
                :disabled="isedit"
                placeholder="结束时间"
                @change="selectTime"
                :picker-options="{
                  selectableRange: selectend
                }"
                v-model="editForm.endTime"
                format="HH:mm"
                style="width: 100%"
              ></el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="edit('editForm')" v-if="editBut && editForm.status != 3">修 改</el-button> -->
        <el-button
          type="primary"
          @click="add('editForm')"
          v-if="Ispostnew && title == '新增待办'"
          >确 定</el-button
        >
        <el-button
          type="success"
          @click="Success(3)"
          v-if="title == '查看待办' && editForm.status != 3"
          >不再提醒</el-button
        >
        <el-button type="warning" @click="del(-1)" v-if="title == '查看待办'"
          >删 除</el-button
        >
        <!-- <el-button @click="callOf('editFormref')" v-else>取 消</el-button> -->
      </span>
    </el-dialog>
    <el-dialog
      title="搜索结果"
      :visible.sync="dialogSearch"
      width="90%"
      center
      height="90%"
    >
      <div style="margin-bottom: 20px">
        <div class="text">
          <div class="icon"></div>
          <div>案件</div>
        </div>
        <el-table
          :data="caseData"
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column prop="code" label="案件编号"> </el-table-column>
          <el-table-column prop="title" label="案件名称"> </el-table-column>
          <el-table-column prop="type" label="案件类型" width="120">
          </el-table-column>
          <el-table-column prop="lawyer" label="承办律师"> </el-table-column>
          <el-table-column prop="entrustmentTime" label="提交时间" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.entrustmentTime">{{
                JsonFTime(scope.row.entrustmentTime)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="案件当事人" pro="lit">
            <template slot-scope="scope">
              <span v-if="scope.row.lit">{{ arrToString(scope.row.lit) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status">
            <template slot-scope="scope">
              <span
                v-if="scope.row.result == 0 && scope.row.status == 0"
                type="text"
                class="casestatus"
                >已通过</span
              >
              <span v-if="scope.row.status == 1" type="text" class="casesresult"
                >待审核</span
              >
              <!-- <span v-if="scope.row.status == 2" type="text" class="casestatus">二次审核中</span> -->
              <span
                v-if="scope.row.result == 1 && scope.row.status == 0"
                type="text"
                class="casesrefuse"
                >未通过</span
              >
              <span v-if="scope.row.status == 2" type="text" class="casestatus"
                >已结案</span
              >
              <span v-if="scope.row.status == 3" type="text" class="casestatus"
                >已归档</span
              >
              <span
                v-if="scope.row.status == -1"
                type="text"
                class="casesrefuse"
                >已删除</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="chakan"
                v-if="$store.state.rolesname.includes('myDetail')"
                size="small"
                @click="CaseLook(scope.row, 'case')"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="text">
          <div class="icon"></div>
          <div>顾问</div>
        </div>
        <el-table
          :data="adviserData"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column
            prop="applyName"
            label="申请人姓名"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="responseUnit"
            label="顾问单位"
            width="180"
          ></el-table-column>
          <el-table-column prop="startTime" label="开始时间"></el-table-column>
          <el-table-column prop="endTime" label="结束时间"></el-table-column>
          <el-table-column prop="unitType" label="单位性质"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="chakan"
                size="small"
                @click="CaseLook(scope.row.id, 'adviser')"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  Link,
  Add,
  Reminder,
  Edit,
  Upadte,
  FirstNotice,
  NoticeRead,
  EnterMenu,
  Search
} from '../../api/First'
import { newDate } from '../../tools/geTime.js'
// import Select from "../../components/case/Select.vue";
export default {
  name: 'firstpage',
  data() {
    return {
      // Isedit:true,
      isedit: false,
      title: '新增待办',
      LinkCase: [], //关联案件
      LinkAdviser: [], //关联顾问
      // NoticeUnread:'',//未读总条数
      IsorNo: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      editrules: {
        abstract: { required: true, message: '不能为空 ', trigger: 'blur' },
        startTime: { required: true, message: '不能为空 ', trigger: 'blur' },
        remind: { required: true, message: '不能为空 ', trigger: 'blur' },
        date:{ required: true, message: '不能为空 ', trigger: 'blur' },
      },
      AddFormrules: {
        abstract: { required: true, message: '不能为空 ', trigger: 'blur' },
        startTime: { required: true, message: '不能为空 ', trigger: 'blur' },
        remind: { required: true, message: '不能为空 ', trigger: 'blur' },
        date:{ required: true, message: '不能为空 ', trigger: 'blur' },
      },
      selectstart: '', //开始时间可选择范围
      selectend: '', //结束时间可选择范围
      selected: null, //选中的日期
      editForm: {
        id: '',
        status: null,
        abstract: '',
        detail: '',
        caseId: null,
        adviserId: null,
        remind: false,
        startTime: null,
        endTime: null,
        date: null
      },
      pickerOptions: {
        //禁止选择今天之前的时间
        disabledDate(time) {
          // 获取当前日期
          const today = new Date()
          today.setHours(0, 0, 0, 0)

          // 将时间戳转换为日期对象
          const date = new Date(time)
          date.setHours(0, 0, 0, 0)

          // 如果日期早于今天，则禁用
          return date < today
        }
      },
      Ispostnew: true, //按钮是否显示
      editBut: true,
      nowtime: new Date(), //日历
      dialogVisibleAdd: false,
      AddForm: {
        abstract: '',
        detail: '',
        caseId: null,
        adviserId: null,
        remind: false,
        startTime: null,
        endTime: null
       
      },
      fileList: [],
      input: '',
      quickcontent: {},
      notice: [], //通知
      // noticeLeft: [], //左边
      // noticeRight: [], //右边
      resDate: [], //数据源，总数据
      dialogVisible: false,
      rcdata: {}, //点击日期里面每天的日程安排

      editFormIndex: '',
      dialogAllthing: false,

      dialogSearch: false,
      caseData: [],
      adviserData: []
    }
  },
  created() {
    this.GetData()
    this.GetLink()
    this.getnotice()
    this.GetEnter()
    // this.GetUnRead()
  },
  components: {},
  methods: {
    search() {
      //搜索
      if (this.input) {
        this.dialogSearch = true
        this.CaseSearch()
      } else {
        this.$message({
          message: '请输入搜索内容',
          type: 'warning'
        })
      }
    },
    CaseSearch() {
      Search({ SearchName: this.input }).then((res) => {
        if (res.data.status == 'success') {
          this.caseData = res.data.data.caseData
          this.adviserData = res.data.data.adviserData
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    CaseLook(item, type) {
      if (type == 'adviser') {
        if (this.$store.state.rolesname.includes('allCounsel')) {
          this.$router.push({
            path: '/home/counsel/allCounsel'
          })
        } else {
          this.$router.push({
            path: '/home/counsel/legalCounsel'
          })
        }
      } else if (type == 'case') {
        var caseType = item.typeid.substring(21, 23)
        console.log(caseType)
        if (caseType == 13) {
          this.$router.push({
            path: 'bankruptdetail',
            name: 'bankruptdetail',
            query: { guid: item.id, type: '破产投标' }
          })
        } else if (caseType == 12) {
          this.$router.push({
            path: 'bankruptdetail',
            name: 'bankruptdetail',
            query: { guid: item.id, type: '破产' }
          })
        } else {
          this.$store.commit('setmenustatus', 1)
          this.$router.push({
            path: '/home/case/caseinfo',
            query: {
              guid: item.id,
              status: item.typeid,
              caseType: caseType,
              mystatus: 1
            }
          })
        }
      }
    },
    GetLink() {
      Link().then((res) => {
        if (res.data.status == 'success') {
          this.LinkCase = res.data.data.linkCase
          this.LinkAdviser = res.data.data.linkAdviser
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetEnter() {
      //获取快捷录入
      EnterMenu().then((res) => {
        if (res.data.status == 'success') {
          // console.log('录入案件类型总数:' + res.data.data)
          this.quickcontent = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    getnotice() {
      FirstNotice().then((res) => {
        if ((res.data.status = 'success')) {
          this.notice = res.data.data
          // if (this.notice.length > 4) {
          //   this.noticeLeft = this.notice.splice(0, 4)
          //   this.noticeRight = this.notice
          //   // console.log(this.noticeRight)
          // } else {
          //   this.noticeLeft = this.notice.splice(0, this.notice.length)
          // }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },

    // pickerOptions(){//时间选择器

    // },
    Previewf(file) {
      // console.log('filename',file);
      // window.open(file.response)
      if (file) {
        const addTypeArray = file.name.split('.')
        const addType = addTypeArray[addTypeArray.length - 1]
        // console.log(addType);
        if (addType === 'pdf') {
          let routeData = this.$router.resolve({
            path: '/insurancePdf',
            query: { url: file.response, showBack: false }
          })
          window.open(routeData.href, '_blank')
        }
        //".rar, .zip, .doc, .docx, .xls, .txt, .pdf, .jpg,  .png, .jpeg,"
        else if (addType === 'doc' || addType === 'docx' || addType === 'xls') {
          window.open(
            'http://view.officeapps.live.com/op/view.aspx?src=' + file.response
          )
        } else if (addType === 'txt') {
          window.open(file.response)
        } else if (['png', 'jpg', 'jpeg'].includes(addType)) {
          window.open(file.response)
        } else if (addType === 'rar' || addType === 'zip') {
          this.$message({
            message: '该文件类型暂不支持预览',
            type: 'warning'
          })
          return false
        }
      }
    },

    addSchedule() {
      this.dialogVisible = true
      this.isedit = false
      this.title = '新增待办'
      this.Ispostnew = true
    },
    detail(id) {
      this.title = '查看待办'
      this.isedit = true
      this.dialogVisible = true
      this.editForm = JSON.parse(
        JSON.stringify(this.resDate.find((x) => x.id == id))
      )
    },
    test(event) {
      console.log('event------', event)
    },
    gonotice() {
      this.$router.push('/home/email')
    },
    quicksearch(item) {
      var type = item.value.substring(21, 23)
      if (type == 12) {
        this.$router.push({
          path: '/home/case/bankinput'
        })
      } else if (type == 13) {
        this.$router.push({
          path: '/home/case/Bidinput'
        })
      } else {
        this.$router.push({
          path: '/home/case/caseinput',
          query: {
            status: item.value,
            num: type,
            sup: false
          }
        })
        this.$store.commit('setinputstatus', 1)
      }
    },
    Look(item) {
      if (item.msgType == 'case_entry') {
        //案件
        var caseType = item.casetype.typeId.substring(21, 23)
        if (item.con.includes('需要审批')) {
          //案件审核
          this.$router.push({
            path: '/home/examine/Casedetail',
            query: {
              guid: item.infoId,
              type: item.casetype.typecase
            }
          })
        } else {
          //案件详情页面
          if (caseType == 13) {
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: item.infoId, type: '破产投标' }
            })
          } else if (caseType == 12) {
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: item.infoId, type: '破产' }
            })
          } else {
            this.$store.commit('setmenustatus', 1)
            this.$router.push({
              path: '/home/case/caseinfo',
              query: {
                guid: item.infoId,
                status: item.casetype.typeId,
                caseType: caseType,
                mystatus: 1
              }
            })
          }
        }
      } else {
        if (item.msgType == 'adviser_entry') {
          if (item.con.includes('需要审批')) {
            this.$router.push({
              path: '/home/counsel/legalCounsel'
            })
          } else {
            this.$router.push({
              path: '/home/counsel/allCounsel'
            })
          }
        } else if (item.msgType == 'reminder_entry') {
          this.$router.push({
            path: '/home/homePage/firstPage'
          })
        } else if (item.msgType.includes('_seal')) {
          if (item.con.includes('需要审批')) {
            //用章审核
            this.$router.push({
              path: '/home/seal/SealApprovedetail',
              query: {
                guid: item.infoId
              }
            })
          } else {
            this.$router.push({
              name: 'Sealdetail',
              path: '/home/seal/Sealdetail',
              query: {
                guid: item.infoId
              }
            })
          }
        } else if (item.msgType == 'tender_entry') {
          if (item.con.includes('需要审批')) {
            //投标审核
            this.$router.push({
              path: '/home/seal/BidApprovedetail',
              query: {
                guid: item.infoId
              }
            })
          } else {
            this.$router.push({
              name: 'Sealdetail',
              path: '/home/seal/Biddetail',
              query: {
                guid: item.infoId
              }
            })
          }
        }
      }
      //未读改成已读
      if (item.status == 1) {
        this.Read(item)
      }
    },
    Read(item) {
      //已读
      if (item.status == 1) {
        NoticeRead({ Id: item.id }).then((res) => {
          if (res.data.status == 'success') {
            item.status = 0
            // this.GetUnRead()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      }
    },

    dateChange(value) {
      if (value) {
        this.editForm.date = this.handleTime(new Date(value), 'yyyy-MM-dd')
        this.editForm.startTime = null
        this.editForm.endTime = null
        this.selectTime()
      } else {
        this.editForm.date = null
      }
    },
    selectTime() {
      //时间变化
      var nowdate = this.handleTime(new Date(), 'yyyy-MM-dd') //今天的日期
      if (nowdate == this.editForm.date) {
        this.selectstart =
          this.handleTime(new Date(), 'HH:mm:ss') + '- 23:59:00'
        this.selectend = this.handleTime(new Date(), 'HH:mm:ss') + '- 23:59:00'
      } else {
        this.selectstart = '00:00:00 - 23:59:00'
        this.selectend = '00:00:00 - 23:59:00'
      }
      if (this.editForm.startTime) {
        this.selectend =
          this.handleTime(this.editForm.startTime, 'HH:mm:ss') + '- 23:59:00'
        if (
          this.handleTime(this.editForm.endTime, 'HH:mm') <
          this.handleTime(this.editForm.startTime, 'HH:mm')
        ) {
          this.editForm.endTime = null
        }
      }
      if (this.editForm.endTime) {
        if (nowdate == this.editForm.date) {
          this.selectstart =
            this.handleTime(new Date(), 'HH:mm:ss') +
            '- ' +
            this.handleTime(this.editForm.endTime, 'HH:mm:ss')
        } else {
          this.selectstart =
            '00:00:00 - ' + this.handleTime(this.editForm.endTime, 'HH:mm:ss')
        }
      }

      // console.log(nowdate)
      // console.log(this.selectstart)
      // console.log(this.selectend)
    },
    closedialog() {
      // this.editForm = {}
      // this.$refs.editForm.resetFields();
      ;(this.editForm = {
        id: '',
        status: null,
        abstract: '',
        detail: '',
        caseId: null,
        adviserId: null,
        remind: false,
        startTime: null,
        endTime: null
      }),
        (this.selectend = '')
      this.selectstart = ''
    },
    postnew() {
      this.title = '新增待办'
      this.editBut = false
      this.dialogVisible = true
      //   this.editForm = {
      //   abstract: "", //事件重要性
      //   time: "", //事件精确时间
      //   content: "",//编辑日程弹出框的内容
      //  };
    },
    // 获取点击日期日程数据
    dealMyDate(v) {
      let res = {
        dayTime: v,
        contents: []
      }
      let res2 = this.resDate.filter((item) => {
        //注意过滤出来的res2，之后对res2修改，原数组resDate数组里面的对象也发生改变
        if (item.dayTime == v) {
          // item.index = index;
          return true
        }
      })[0]

      return res2 || res
    },
    del(item) {
      this.$confirm('此操作将删除该日程，不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Upadte({ Id: this.editForm.id, Status: item }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success(res.data.message)
              this.dialogVisible = false
              this.GetData()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    SuccessOk(id) {
      Upadte({ Id: id, Status: 3 }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success(res.data.message)
          this.dialogVisible = false
          this.GetData()
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    Success(item) {
      Upadte({ Id: this.editForm.id, Status: item }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success(res.data.message)
          this.dialogVisible = false
          this.GetData()
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    GetData() {
      //获取所有日程
      Reminder().then((res) => {
        if (res.data.status == 'success') {
          this.resDate = res.data.data
          // console.log(this.selected)
          // if (this.selected) {
          //   this.rcdata = this.resDate.find((x) => x.dayTime == this.selected)
          //   if (!this.rcdata) {
          //     this.rcdata = {
          //       dayTime: this.selected,
          //       contents: []
          //     }
          //   }
          // }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    // 添加或修改日程
    add(form) {
      if (
        this.editForm.endTime &&
        this.handleTime(this.editForm.endTime, 'HH:mm') <
          this.handleTime(this.editForm.startTime, 'HH:mm')
      ) {
        return this.$message.error('结束时间不能小于开始时间')
      }
      this.$refs[form].validate((success) => {
        if (success) {
          var start = this.JsonTime(
            this.editForm.date +
              ' ' +
              this.handleTime(this.editForm.startTime, 'HH:mm:ss')
          )

          var end = null
          if (this.editForm.endTime) {
            end = this.JsonTime(
              this.editForm.date +
                ' ' +
                this.handleTime(this.editForm.endTime, 'HH:mm:ss')
            )
          }
          Add({
            Abstract: this.editForm.abstract,
            Detail: this.editForm.detail,
            CaseId: this.editForm.caseId,
            AdviserId: this.editForm.adviserId,
            StartTime: start,
            EndTime: end,
            Remind: this.editForm.remind
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success(res.data.message)
              this.dialogVisible = false
              this.GetData()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.$message.error('有必填项为空')
        }
      })
    },
    edit(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          var start = this.JsonTime(
            this.selected +
              ' ' +
              this.handleTime(this.editForm.startTime, 'HH:mm:ss')
          )
          var end = null
          if (this.editForm.endTime) {
            end = this.JsonTime(
              this.selected +
                ' ' +
                this.handleTime(this.editForm.endTime, 'HH:mm:ss')
            )
          }
          Edit({
            Id: this.editForm.id,
            Abstract: this.editForm.abstract,
            Detail: this.editForm.detail,
            CaseId: this.editForm.caseId,
            AdviserId: this.editForm.adviserId,
            StartTime: start,
            EndTime: end,
            Remind: this.remind
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('编辑成功')
              this.GetData()
              this.dialogVisible = false

              // console.log(this.selected)
              // console.log(this.rcdata)
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    // 取消修改或添加
    callOf(formName) {
      // console.log("sadad", formName);
      // this.$refs.formName.resetFields();
      // this.$refs['formName'].clearValidate()
      // this.editFormIndex = "";
      // this.editForm = {
      //   abstract: "", //事件重要性
      //   time: "", //事件精确时间
      //   content: ""
      // };
      // this.dialogVisible = false;
    },
    //时间转换
    handleTime(time, format) {
      if (time == null || time == undefined || time == '') {
        return ''
      }
      var t = new Date(time.toString().replace(/-/g, '/'))
      var tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
            break
          case 'MM':
            return tf(t.getMonth() + 1)
            break
          case 'mm':
            return tf(t.getMinutes())
            break
          case 'dd':
            return tf(t.getDate())
            break
          case 'HH':
            return tf(t.getHours())
            break
          case 'ss':
            return tf(t.getSeconds())
            break
        }
      })
    },
    arrToString(arr) {
      return arr.join(' , ')
    },
    // 时间格式
    JsonFTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },

  filters: {
    // 获取农历日期
    lunarCalendar(date, calendar) {
      //第一个参数默认为过滤元素这个值，第二个参数是传递过来的参数
      let res = date.split('-')
      return calendar.solar2lunar(res[0], res[1], res[2]).IDayCn
    },
    lunarCalendarStr(date) {
      return '(' + date + ')'
    },
    // 展示日程时间 为 时与分
    getWantTime(time) {
      return newDate(time)
    }
  }
}
</script>
  
<style lang="less" scoped>
#all {
  overflow: hidden;
  width: 100%;
}

.main-left {
  width: 49%;
}

.main-right {
  width: 49%;
}

.main-top {
  width: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}

.search_card {
  border-radius: 16px;

  /deep/.el-card__body,
  .el-main {
    padding: 0;
  }
}

.search {
  width: 100%;
  margin-bottom: 20px;
  height: 90px;

  .searchbox {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;
    // height: 30%;
    background-color: #fff;
    border-radius: 10px;

    ::v-deep .el-input__inner {
      // width: 80% !important;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }
  }
}

.quickbox {
  box-sizing: border-box;
  width: 100%;
  height: 244px;
  padding: 0 20px 20px 20px;
  border-radius: 10px;
  margin: 20px 0 0 0;
  background-color: #fff;

  // overflow-y: scroll;
  // overflow-x: hidden;
  .title {
    color: #081735;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;

    .quickcontent {
      width: 30%;
      height: 30px;
      color: #718096;
      text-align: center;
      line-height: 30px;
      background-color: #fafafa;
      border-radius: 5px;
      margin: 4px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
}

.enter {
  width: 100%;
}

.enter-card {
  border-radius: 16px;

  /deep/.el-card__body,
  .el-main {
    padding: 0;
  }
}

.notice_card {
  border-radius: 16px;
  height: 376px;
}

.things {
  width: 100%;
  padding: 0 10px;
  margin-top: 20px;
}

.schedule {
  border-radius: 16px;
  min-height: calc(100vh - 500px);

  .title {
    color: #081735;
    font-size: 18px;
    font-weight: 600;
  }

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .addthing {
    background-color: #fe964a;
    color: #ffffff;
    padding: 5px 10px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
  }
  .main {
    width: 100%;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .main_con {
    width: 50%;
  }
}

/deep/ .quickbox::-webkit-scrollbar-thumb {
  background: #ffffff !important;
}

::v-deep .el-dialog__title {
  // display: flex;
  // justify-content: center;
  // padding-left: 40%;
  font-weight: 400;
  font-size: 16px;
  color: black;
}

::v-deep .el-form-item__label {
  font-weight: 400;
  font-size: 16px;
  color: black;
}

.noticebox {
  background-color: #fff;
  width: 100%;
  margin-right: 20px;

  .title {
    color: #081735;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
    margin-bottom: 10px;

    &:hover {
      color: #3077e6;
    }
  }

  .notice {
    // display: flex;
    // align-items: center;
    width: 100%;
    height: 88%;
    border-radius: 10px;
    background-color: #fff;
  }

  .content {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    justify-content: space-between;
  }
}
.detail {
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #718096;
  font-size: 12px;
  margin-top: 20px;
  maegin-right: 2%;
}
.icon {
  width: 3.5px;
  height: 12px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}
.d-top {
  width: 100%;
  display: flex;
  align-items: center;
}
.d-main {
  font-size: 16px;
  color: rgb(17, 24, 39);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-top: 8px;
}
.detail-left {
  cursor: pointer;
}
.detail-right {
  color: #8ab1f1;
  background-color: #edf2ff;
  border-radius: 16px;
  min-width: 52px;
  text-align: center;
  cursor: pointer;
  padding: 8px;
}
// 弹出框
#all /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

.chakan {
  // background: #E7F7EF;
  border-radius: 8px;
  color: #0caf60;
  cursor: default;
  border: none;
}

.text {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  margin-bottom: 12px;
}
</style>